import { memo } from "react";
function TrailerDropHookIcon({color="#05A792", width, height}) {
  return (
    <svg
      width={width ?? "14"}
      height={height ?? "12"}
      viewBox="0 0 14 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3327 8.0003V3.33366V0.666992H1.99935C1.26602 0.666992 0.666016 1.26699 0.666016 2.00033V9.3337H1.99935C1.99935 10.4403 2.89268 11.3337 3.99935 11.3337C5.10602 11.3337 5.99935 10.4403 5.99935 9.3337H9.9993C9.9993 9.3337 10.8927 9.3337 11.9994 9.3337H13.3327V8.0003H11.3327ZM3.99935 10.0003C3.63268 10.0003 3.33268 9.7003 3.33268 9.3337C3.33268 8.967 3.63268 8.667 3.99935 8.667C4.36602 8.667 4.66602 8.967 4.66602 9.3337C4.66602 9.7003 4.36602 10.0003 3.99935 10.0003ZM5.47935 8.0003C5.11268 7.59366 4.59268 7.33366 3.99935 7.33366C3.40602 7.33366 2.88602 7.59366 2.51935 8.0003H1.99935V2.00033H9.9993V8.0003H5.47935Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(TrailerDropHookIcon);